import { helpers, required, maxLength } from "@vuelidate/validators";
import { computed } from "vue";
import { validTel } from "common/src/utils/validate";

export const SCR130FormValidateRule = computed(() => ({
  rnw01p: {
    tfRekytl: {
      max: helpers.withMessage(({ $params }) => `その他電話番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(13)),
      tel: helpers.withMessage("その他電話番号はハイフン付きで入力してください", validTel),
    },
    tfRekyt2: {
      max: helpers.withMessage(({ $params }) => `携帯電話番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(13)),
      tel: helpers.withMessage("携帯電話番号はハイフン付きで入力してください", validTel),
    },
    tfRehkpl: {
      required: helpers.withMessage("合計保険料を選択してください", required),
    },
    tfRethcm: {
      any: () => true,
    },
  },
  rnw02p: {
    tfRhhktl: {
      max: helpers.withMessage(({ $params }) => `その他電話番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(13)),
      tel: helpers.withMessage("その他電話番号はハイフン付きで入力してください", validTel),
    },
    tfRhhkt2: {
      max: helpers.withMessage(({ $params }) => `携帯電話番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(13)),
      tel: helpers.withMessage("携帯電話番号はハイフン付きで入力してください", validTel),
    },
  },
}));
